import apiClient from '../../../common/functions/api_axios_instance.function';

export const getSystemPoAuthorizedRecordByPo = async (po) => {
  try {
    const poSafe = encodeURIComponent(String(po || '').trim());
    const response = await apiClient.get(
      `/systemInvoiceManagement/purchaseOrderManagement/authorized-records/by-po/${poSafe}`
    );
    if (response.status === 200) {
      return {
        success: true,
        data: response.data?.response || response.data?.data || response.data,
        message: response.data?.message || 'System PO fetched successfully',
      };
    }
    return {
      success: false,
      status: response.status,
      error: response.data?.message || response.data?.error || 'Failed to fetch System PO',
    };
  } catch (error) {
    return {
      success: false,
      status: error?.response?.status,
      error:
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        'Failed to fetch System PO',
    };
  }
};

export const getSystemPoAuthorizedRecordByPoWithItemsAndClaims = async (po) => {
  try {
    const poSafe = encodeURIComponent(String(po || '').trim());
    const response = await apiClient.get(
      `/systemInvoiceManagement/purchaseOrderManagement/authorized-records/by-po/${poSafe}/with-items-and-claims`
    );
    if (response.status === 200) {
      return {
        success: true,
        data: response.data?.response || response.data?.data || response.data,
        message: response.data?.message || 'System PO fetched successfully',
      };
    }
    return {
      success: false,
      status: response.status,
      error: response.data?.message || response.data?.error || 'Failed to fetch System PO',
    };
  } catch (error) {
    return {
      success: false,
      status: error?.response?.status,
      error:
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        'Failed to fetch System PO',
    };
  }
};
